import { render, staticRenderFns } from "./view_manage.vue?vue&type=template&id=6186423e&scoped=true"
import script from "./view_manage.vue?vue&type=script&lang=js"
export * from "./view_manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186423e",
  null
  
)

export default component.exports